import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function ActivityInputs({ id, label, tooltip, tooltipHeader, tooltipText, questionValue, onChange }) {
  return (
    <fieldset>
      <OverlayTrigger
        rootClose
        placement="right-start"
        trigger={tooltip ? ["hover"] : null}
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>{tooltipHeader}</strong>
            <br />
            {tooltipText}
          </Tooltip>
        }
      >
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Col>
            <Form.Check
              id={id + "1"}
              inline
              type="radio"
              label="No"
              name={id}
              checked={questionValue === "false"}
              value={"false"}
              onChange={onChange}
            />
            <Form.Check
              id={id + "2"}
              inline
              type="radio"
              label="Yes"
              name={id}
              checked={questionValue === "true"}
              value={"true"}
              onChange={onChange}
            />
          </Col>
        </Form.Group>
      </OverlayTrigger>
    </fieldset>
  );
}
